// @flow
import React, { Component } from 'react'

import AuthService from 'client/utils/auth-service'
import DefaultForm from './strategies/auth0'
import ADFSForm from './strategies/enterprise/adfs'
import GoogleForm from './strategies/enterprise/google'
import SamlpForm from './strategies/enterprise/samlp'
import WAADForm from './strategies/enterprise/waad'
import OktaForm from './strategies/enterprise/okta'

const STRATEGIES = {
  adfs: ADFSForm,
  auth0: DefaultForm,
  'google-apps': GoogleForm,
  'google-oauth2': GoogleForm,
  'samlp': SamlpForm,
  'waad': WAADForm,
  'okta': OktaForm
}
// $FlowFixMe
export default class extends Component {
  props: {
    auth: AuthService,
    client: {
      redirectUri: string,
      connections: Array<{
        connection: string,
        strategy: string
      }>
    }
  }

  static displayName: any = 'Form'

  render (): any {
    const { auth, client: { redirectUri, connections } } = this.props
    return (
      <div className='login__connections'>
        {
          connections.map((connection, key) => {
            const Form = STRATEGIES[connection.strategy]
            return Form ? <Form auth={auth} redirectUri={redirectUri} connection={connection} key={key} /> : null
          })
        }
      </div>
    )
  }
}
